const eventBus = new EventTarget();

export const DARK_MODE_CHANGE_EVENT = 'darkModeChange';

export default eventBus;